/* eslint-disable */ 

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ApiClientBase,
  API_BASE_URL
} from '@mds/angular-core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AppsClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getApps(throwError?: boolean): Observable<AppModel[]> {
      let url = this.baseUrl + '/internal/v1.0/apps';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AppModel[]>(url, this.jsonOptions), throwError);
  }

  addApp(model: AddApp, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/apps';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  getById(id: string, throwError?: boolean): Observable<AppModel> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AppModel>(url, this.jsonOptions), throwError);
  }

  deleteApp(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  updateApp(id: string, model: UpdateApp, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  isDeletable(id: string, throwError?: boolean): Observable<boolean> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}/deletable';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<boolean>(url, this.jsonOptions), throwError);
  }

  getScopeById(appId: string, scopeId: string, throwError?: boolean): Observable<ScopeModel> {
      let url = this.baseUrl + '/internal/v1.0/apps/{appId}/scopes/{scopeId}';
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    if (scopeId === undefined || scopeId === null) {
        throw new Error('The parameter \'scopeId\' must be defined.');
    }
    url = url.replace('{scopeId}', encodeURIComponent('' + scopeId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeModel>(url, this.jsonOptions), throwError);
  }

  deleteScope(appId: string, scopeId: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/apps/{appId}/scopes/{scopeId}';
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    if (scopeId === undefined || scopeId === null) {
        throw new Error('The parameter \'scopeId\' must be defined.');
    }
    url = url.replace('{scopeId}', encodeURIComponent('' + scopeId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  updateScope(appId: string, scopeId: string, model: UpdateScope, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/apps/{appId}/scopes/{scopeId}';
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    if (scopeId === undefined || scopeId === null) {
        throw new Error('The parameter \'scopeId\' must be defined.');
    }
    url = url.replace('{scopeId}', encodeURIComponent('' + scopeId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getScopes(appId: string, throwError?: boolean): Observable<ScopeModel[]> {
      let url = this.baseUrl + '/internal/v1.0/apps/{appId}/scopes';
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeModel[]>(url, this.jsonOptions), throwError);
  }

  addScope(appId: string, model: AddScope, throwError?: boolean): Observable<ScopeModel> {
      let url = this.baseUrl + '/internal/v1.0/apps/{appId}/scopes';
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<ScopeModel>(url, model, this.jsonOptions), throwError);
  }

  isScopeDeletable(appId: string, scopeId: string, throwError?: boolean): Observable<boolean> {
      let url = this.baseUrl + '/internal/v1.0/apps/{appId}/scopes/{scopeId}/deletable';
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    if (scopeId === undefined || scopeId === null) {
        throw new Error('The parameter \'scopeId\' must be defined.');
    }
    url = url.replace('{scopeId}', encodeURIComponent('' + scopeId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<boolean>(url, this.jsonOptions), throwError);
  }

  addScopeParameterNames(id: string, model: AddScopeParameterNamesToApp, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}/scopeparameternames';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeScopeParameterNames(id: string, model: RemoveScopeParameterNamesFromApp, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}/scopeparameternames';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getScopeParameterNames(id: string, throwError?: boolean): Observable<ScopeParameterNameModel[]> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}/scopeparameternames';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterNameModel[]>(url, this.jsonOptions), throwError);
  }

  isScopeParameterNameRemovable(id: string, scopeParameterNameId: string, throwError?: boolean): Observable<boolean> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}/scopes/{scopeParameterNameId}/removable';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (scopeParameterNameId === undefined || scopeParameterNameId === null) {
        throw new Error('The parameter \'scopeParameterNameId\' must be defined.');
    }
    url = url.replace('{scopeParameterNameId}', encodeURIComponent('' + scopeParameterNameId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<boolean>(url, this.jsonOptions), throwError);
  }

  getAssignableScopeParameterNames(id: string, throwError?: boolean): Observable<ScopeParameterNameModel[]> {
      let url = this.baseUrl + '/internal/v1.0/apps/{id}/assignable-scopeparameternames';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterNameModel[]>(url, this.jsonOptions), throwError);
  }

  getBuiltInRoles(appId: string, throwError?: boolean): Observable<RoleModel[]> {
      let url = this.baseUrl + '/internal/v1.0/apps/{appId}/builtin-roles';
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleModel[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuditsClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getAudits(minCreatedDate?: Date | undefined, maxCreatedDate?: Date | undefined, activities?: AuditActivity[] | null | undefined, targetId?: string | null | undefined, targetName?: string | null | undefined, targetTypes?: AuditTargetType[] | null | undefined, actorId?: string | null | undefined, actorName?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, throwError?: boolean): Observable<PaginatedResultOfAuditListModel> {
      let url = this.baseUrl + '/internal/v1.0/audits?';
    if (minCreatedDate === null) {
        throw new Error('The parameter \'minCreatedDate\' cannot be null.');
    } else if (minCreatedDate !== undefined) {
        url += 'MinCreatedDate=' + encodeURIComponent(minCreatedDate ? '' + minCreatedDate.toJSON() : '') + '&'; 
    }
    if (maxCreatedDate === null) {
        throw new Error('The parameter \'maxCreatedDate\' cannot be null.');
    } else if (maxCreatedDate !== undefined) {
        url += 'MaxCreatedDate=' + encodeURIComponent(maxCreatedDate ? '' + maxCreatedDate.toJSON() : '') + '&'; 
    }
    if (activities !== undefined) {
        activities && activities.forEach(item => { url += 'Activities=' + encodeURIComponent('' + item) + '&'; });
    }
    if (targetId !== undefined) {
        url += 'TargetId=' + encodeURIComponent('' + targetId) + '&'; 
    }
    if (targetName !== undefined) {
        url += 'TargetName=' + encodeURIComponent('' + targetName) + '&'; 
    }
    if (targetTypes !== undefined) {
        targetTypes && targetTypes.forEach(item => { url += 'TargetTypes=' + encodeURIComponent('' + item) + '&'; });
    }
    if (actorId !== undefined) {
        url += 'ActorId=' + encodeURIComponent('' + actorId) + '&'; 
    }
    if (actorName !== undefined) {
        url += 'ActorName=' + encodeURIComponent('' + actorName) + '&'; 
    }
    if (skip !== undefined) {
        url += 'Skip=' + encodeURIComponent('' + skip) + '&'; 
    }
    if (take !== undefined) {
        url += 'Take=' + encodeURIComponent('' + take) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PaginatedResultOfAuditListModel>(url, this.jsonOptions), throwError);
  }

  getById(id: string, throwError?: boolean): Observable<AuditModel> {
      let url = this.baseUrl + '/internal/v1.0/audits/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AuditModel>(url, this.jsonOptions), throwError);
  }

  getTargets(id: string, throwError?: boolean): Observable<AuditTargetListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/audits/{id}/targets';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AuditTargetListModel[]>(url, this.jsonOptions), throwError);
  }

  getChanges(id: string, throwError?: boolean): Observable<AuditChangeListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/audits/{id}/changes';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AuditChangeListModel[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ClientsClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getClients(filter?: string | null | undefined, sortField?: string | null | undefined, sortOrder?: SortOrder | undefined, skip?: number | null | undefined, take?: number | null | undefined, clientKinds?: ClientKind[] | null | undefined, tagIds?: string[] | null | undefined, throwError?: boolean): Observable<PaginatedResultOfClientListModel> {
      let url = this.baseUrl + '/internal/v1.0/clients?';
    if (filter !== undefined) {
        url += 'Filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (sortField !== undefined) {
        url += 'SortField=' + encodeURIComponent('' + sortField) + '&'; 
    }
    if (sortOrder === null) {
        throw new Error('The parameter \'sortOrder\' cannot be null.');
    } else if (sortOrder !== undefined) {
        url += 'SortOrder=' + encodeURIComponent('' + sortOrder) + '&'; 
    }
    if (skip !== undefined) {
        url += 'Skip=' + encodeURIComponent('' + skip) + '&'; 
    }
    if (take !== undefined) {
        url += 'Take=' + encodeURIComponent('' + take) + '&'; 
    }
    if (clientKinds !== undefined) {
        clientKinds && clientKinds.forEach(item => { url += 'ClientKinds=' + encodeURIComponent('' + item) + '&'; });
    }
    if (tagIds !== undefined) {
        tagIds && tagIds.forEach(item => { url += 'TagIds=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PaginatedResultOfClientListModel>(url, this.jsonOptions), throwError);
  }

  addClient(model: AddClient, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/clients';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  getById(id: string, throwError?: boolean): Observable<ClientModel> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ClientModel>(url, this.jsonOptions), throwError);
  }

  deleteClient(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  updateClient(id: string, model: UpdateClient, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getPermissions(id: string, throwError?: boolean): Observable<PermissionsListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/permissions';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PermissionsListModel[]>(url, this.jsonOptions), throwError);
  }

  getGroups(id: string, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  addGroups(id: string, model: AddGroupsToClient, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeGroups(id: string, model: RemoveGroupsFromClient, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getAssignableGroups(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/assignable-groups?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  getRedirectUris(clientId: string, throwError?: boolean): Observable<RedirectUriListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/redirecturis';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RedirectUriListModel[]>(url, this.jsonOptions), throwError);
  }

  addRedirectUri(clientId: string, model: AddRedirectUri, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/redirecturis';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  deleteRedirectUri(clientId: string, redirectUriId: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/redirecturis/{redirectUriId}';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    if (redirectUriId === undefined || redirectUriId === null) {
        throw new Error('The parameter \'redirectUriId\' must be defined.');
    }
    url = url.replace('{redirectUriId}', encodeURIComponent('' + redirectUriId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  getPostLogoutRedirectUris(clientId: string, throwError?: boolean): Observable<PostLogoutRedirectUriListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/postlogoutredirecturis';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PostLogoutRedirectUriListModel[]>(url, this.jsonOptions), throwError);
  }

  addPostLogoutRedirectUri(clientId: string, model: AddPostLogoutRedirectUri, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/postlogoutredirecturis';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  deletePostLogoutRedirectUri(clientId: string, postLogoutRedirectUriId: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/postlogoutredirecturis/{postLogoutRedirectUriId}';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    if (postLogoutRedirectUriId === undefined || postLogoutRedirectUriId === null) {
        throw new Error('The parameter \'postLogoutRedirectUriId\' must be defined.');
    }
    url = url.replace('{postLogoutRedirectUriId}', encodeURIComponent('' + postLogoutRedirectUriId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  getSecrets(clientId: string, throwError?: boolean): Observable<SecretListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/secrets';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<SecretListModel[]>(url, this.jsonOptions), throwError);
  }

  addSecret(clientId: string, model: AddSecret, throwError?: boolean): Observable<AddSecretModel> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/secrets';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<AddSecretModel>(url, model, this.jsonOptions), throwError);
  }

  deleteSecret(clientId: string, secretId: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/secrets/{secretId}';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    if (secretId === undefined || secretId === null) {
        throw new Error('The parameter \'secretId\' must be defined.');
    }
    url = url.replace('{secretId}', encodeURIComponent('' + secretId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  addApiKey(clientId: string, model: AddApiKey, throwError?: boolean): Observable<AddApiKeyModel> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/apikeys';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<AddApiKeyModel>(url, model, this.jsonOptions), throwError);
  }

  getApiKeys(clientId: string, throwError?: boolean): Observable<ApiKeyListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/apikeys';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ApiKeyListModel[]>(url, this.jsonOptions), throwError);
  }

  deleteApiKey(clientId: string, apiKeyId: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/apikeys/{apiKeyId}';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    if (apiKeyId === undefined || apiKeyId === null) {
        throw new Error('The parameter \'apiKeyId\' must be defined.');
    }
    url = url.replace('{apiKeyId}', encodeURIComponent('' + apiKeyId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  getAssignableApiKeyPermissions(clientId: string, appId: string, throwError?: boolean): Observable<PermissionsListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/apikeys/assignable-permissions?';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined and cannot be null.');
    } else {
        url += 'appId=' + encodeURIComponent('' + appId) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PermissionsListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableApiKeyApps(clientId: string, throwError?: boolean): Observable<ApiKeyAppsListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{clientId}/apikeys/assignable-apps';
    if (clientId === undefined || clientId === null) {
        throw new Error('The parameter \'clientId\' must be defined.');
    }
    url = url.replace('{clientId}', encodeURIComponent('' + clientId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ApiKeyAppsListModel[]>(url, this.jsonOptions), throwError);
  }

  getRoleAssignments(id: string, throwError?: boolean): Observable<RoleAssignmentListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleAssignmentListModel[]>(url, this.jsonOptions), throwError);
  }

  addRoleAssignments(id: string, model: AddRoleAssignments, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeRoleAssignments(id: string, model: RemoveRoleAssignment, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getAssignableScopeParameterValues(roleId?: string | undefined, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<ScopeParameterValueListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/assignable-scopeparametervalues?';
    if (roleId === null) {
        throw new Error('The parameter \'roleId\' cannot be null.');
    } else if (roleId !== undefined) {
        url += 'roleId=' + encodeURIComponent('' + roleId) + '&'; 
    }
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterValueListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableRoles(filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<RoleListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/assignable-roles?';
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleListModel[]>(url, this.jsonOptions), throwError);
  }

  getTags(id: string, throwError?: boolean): Observable<TagModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/tags';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<TagModel[]>(url, this.jsonOptions), throwError);
  }

  addTags(id: string, model: AddTags, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/tags';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeTags(id: string, model: RemoveTags, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/tags';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getOrganizationTags(filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<TagSelectionModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/tags?';
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<TagSelectionModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableTags(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<TagSelectionModel[]> {
      let url = this.baseUrl + '/internal/v1.0/clients/{id}/assignable-tags?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<TagSelectionModel[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ConfigClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  config(throwError?: boolean): Observable<ConfigurationModel> {
      let url = this.baseUrl + '/internal/v1.0/config';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ConfigurationModel>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class GroupsClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getGroups(filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups?';
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  addGroup(model: AddGroup, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/groups';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  getById(id: string, throwError?: boolean): Observable<GroupModel> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupModel>(url, this.jsonOptions), throwError);
  }

  deleteGroup(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  updateGroup(id: string, model: UpdateGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getUsers(id: string, throwError?: boolean): Observable<UserNameListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/users';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserNameListModel[]>(url, this.jsonOptions), throwError);
  }

  addUsers(id: string, model: AddUsersToGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/users';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeUsers(id: string, model: RemoveUsersFromGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/users';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getClients(id: string, throwError?: boolean): Observable<ClientNameListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/clients';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ClientNameListModel[]>(url, this.jsonOptions), throwError);
  }

  addClients(id: string, model: AddClientsToGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/clients';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeClients(id: string, model: RemoveClientsFromGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/clients';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getOwners(id: string, throwError?: boolean): Observable<UserNameListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/owners';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserNameListModel[]>(url, this.jsonOptions), throwError);
  }

  addOwners(id: string, model: AddOwnersToGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/owners';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeOwners(id: string, model: RemoveOwnersFromGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/owners';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getGroupsInGroup(id: string, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  addGroups(id: string, model: AddGroupsToGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeGroups(id: string, model: RemoveGroupsFromGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getGroupMemberships(id: string, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/group-memberships';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  addGroupMemberships(id: string, model: AddGroupMembershipsToGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/group-memberships';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeGroupMemberships(id: string, model: RemoveGroupsFromGroup, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/group-memberships';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getRoleAssignments(id: string, throwError?: boolean): Observable<RoleAssignmentListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleAssignmentListModel[]>(url, this.jsonOptions), throwError);
  }

  addRoleAssignments(id: string, model: AddRoleAssignments, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeRoleAssignments(id: string, model: RemoveRoleAssignment, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getAssignableUsers(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<UserNameListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/assignable-users?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserNameListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableClients(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<ClientNameListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/assignable-clients?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ClientNameListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableGroups(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/assignable-groups?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableGroupMemberships(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/assignable-group-memberships?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableOwners(id: string, throwError?: boolean): Observable<UserNameListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/{id}/assignable-owners';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserNameListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableScopeParameterValues(roleId?: string | undefined, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<ScopeParameterValueListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/assignable-scopeparametervalues?';
    if (roleId === null) {
        throw new Error('The parameter \'roleId\' cannot be null.');
    } else if (roleId !== undefined) {
        url += 'roleId=' + encodeURIComponent('' + roleId) + '&'; 
    }
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterValueListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableRoles(filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<RoleListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/groups/assignable-roles?';
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleListModel[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class InvitationsClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getInvitations(filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<InvitationListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/invitations?';
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<InvitationListModel[]>(url, this.jsonOptions), throwError);
  }

  createInvitation(model: CreateInvitation, throwError?: boolean): Observable<AddInvitationModel> {
      let url = this.baseUrl + '/internal/v1.0/invitations';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<AddInvitationModel>(url, model, this.jsonOptions), throwError);
  }

  getById(id: string, throwError?: boolean): Observable<InvitationModel> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<InvitationModel>(url, this.jsonOptions), throwError);
  }

  revokeInvitation(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  resendInvitation(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, this.jsonOptions), throwError);
  }

  updateInvitation(id: string, model: UpdateInvitation, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.put<void>(url, model, this.jsonOptions), throwError);
  }

  bulkRevokeInvitations(model: BulkRevokeInvitations, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/bulk-revoke';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  bulkResendInvitations(model: BulkResendInvitations, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/bulk-resend';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  getGroups(id: string, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  addGroups(id: string, model: AddGroupsToInvitation, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeGroups(id: string, model: RemoveGroupsFromInvitation, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getAssignableGroups(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}/assignable-groups?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  getPermissions(id: string, throwError?: boolean): Observable<PermissionsListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}/permissions';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PermissionsListModel[]>(url, this.jsonOptions), throwError);
  }

  getRoleAssignments(id: string, throwError?: boolean): Observable<RoleAssignmentListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleAssignmentListModel[]>(url, this.jsonOptions), throwError);
  }

  addRoleAssignments(id: string, model: AddRoleAssignments, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeRoleAssignments(id: string, model: RemoveRoleAssignment, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/invitations/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getAssignableScopeParameterValues(roleId?: string | undefined, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<ScopeParameterValueListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/invitations/assignable-scopeparametervalues?';
    if (roleId === null) {
        throw new Error('The parameter \'roleId\' cannot be null.');
    } else if (roleId !== undefined) {
        url += 'roleId=' + encodeURIComponent('' + roleId) + '&'; 
    }
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterValueListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableRoles(filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<RoleListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/invitations/assignable-roles?';
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleListModel[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class MeClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getScopeParameterValues(scopeParameterName: string, throwError?: boolean): Observable<UserScopeParameterValueModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/me/scopeparametervalues?';
    if (scopeParameterName === undefined || scopeParameterName === null) {
        throw new Error('The parameter \'scopeParameterName\' must be defined and cannot be null.');
    } else {
        url += 'ScopeParameterName=' + encodeURIComponent('' + scopeParameterName) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserScopeParameterValueModel[]>(url, this.jsonOptions), throwError);
  }

  getCurrentScopeParameterValues(scopeParameterName: string, throwError?: boolean): Observable<UserScopeParameterValueModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/me/scopeparametervalues/current?';
    if (scopeParameterName === undefined || scopeParameterName === null) {
        throw new Error('The parameter \'scopeParameterName\' must be defined and cannot be null.');
    } else {
        url += 'ScopeParameterName=' + encodeURIComponent('' + scopeParameterName) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserScopeParameterValueModel[]>(url, this.jsonOptions), throwError);
  }

  getScopeParameters(queryParameters?: { [key: string]: any[]; } | undefined, throwError?: boolean): Observable<UserScopeParametersResultModel> {
      let url = this.baseUrl + '/internal/v1.0/users/me/scopeparameters?';
    if (queryParameters === null) {
        throw new Error('The parameter \'queryParameters\' cannot be null.');
    } else if (queryParameters !== undefined) {
        url += 'QueryParameters=' + encodeURIComponent('' + queryParameters) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserScopeParametersResultModel>(url, this.jsonOptions), throwError);
  }

  getScopes(throwError?: boolean): Observable<UserScopesModel> {
      let url = this.baseUrl + '/internal/v1.0/users/me/scopes/current';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserScopesModel>(url, this.jsonOptions), throwError);
  }

  validateCallbackUrl(model: ValidateCallbackUrlModel, throwError?: boolean): Observable<ValidatedCallbackUrlResponseModel> {
      let url = this.baseUrl + '/internal/v1.0/users/me/validate-callbackurl';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<ValidatedCallbackUrlResponseModel>(url, model, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class MyOrganizationClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getMyOrganization(throwError?: boolean): Observable<OrganizationOverviewModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<OrganizationOverviewModel>(url, this.jsonOptions), throwError);
  }

  getSourceVendor(throwError?: boolean): Observable<OrganizationSourceVendorModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/source-vendor';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<OrganizationSourceVendorModel>(url, this.jsonOptions), throwError);
  }

  setSourceVendor(model: SetSourceVendor, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/source-vendor';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.put<void>(url, model, this.jsonOptions), throwError);
  }

  getApps(throwError?: boolean): Observable<AppModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/apps';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AppModel[]>(url, this.jsonOptions), throwError);
  }

  getAppById(appId: string, throwError?: boolean): Observable<AppModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/apps/{appId}';
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AppModel>(url, this.jsonOptions), throwError);
  }

  getTags(filter?: string | null | undefined, sortField?: string | null | undefined, sortOrder?: SortOrder | undefined, skip?: number | null | undefined, take?: number | null | undefined, throwError?: boolean): Observable<PaginatedResultOfTagModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/tags?';
    if (filter !== undefined) {
        url += 'Filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (sortField !== undefined) {
        url += 'SortField=' + encodeURIComponent('' + sortField) + '&'; 
    }
    if (sortOrder === null) {
        throw new Error('The parameter \'sortOrder\' cannot be null.');
    } else if (sortOrder !== undefined) {
        url += 'SortOrder=' + encodeURIComponent('' + sortOrder) + '&'; 
    }
    if (skip !== undefined) {
        url += 'Skip=' + encodeURIComponent('' + skip) + '&'; 
    }
    if (take !== undefined) {
        url += 'Take=' + encodeURIComponent('' + take) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PaginatedResultOfTagModel>(url, this.jsonOptions), throwError);
  }

  addTag(model: AddTag, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/tags';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  getTagNames(throwError?: boolean): Observable<TagNameSelectionModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/tag-names';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<TagNameSelectionModel[]>(url, this.jsonOptions), throwError);
  }

  getTagById(tagId: string, throwError?: boolean): Observable<TagModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/tags/{tagId}';
    if (tagId === undefined || tagId === null) {
        throw new Error('The parameter \'tagId\' must be defined.');
    }
    url = url.replace('{tagId}', encodeURIComponent('' + tagId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<TagModel>(url, this.jsonOptions), throwError);
  }

  deleteTag(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/tags/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  updateTag(id: string, model: UpdateTag, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/mine/tags/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class OrganizationsClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getById(id: string, throwError?: boolean): Observable<OrganizationModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<OrganizationModel>(url, this.jsonOptions), throwError);
  }

  updateOrganization(id: string, model: UpdateOrganization, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  deleteOrganization(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  getOrganizations(throwError?: boolean): Observable<OrganizationModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<OrganizationModel[]>(url, this.jsonOptions), throwError);
  }

  addOrganization(model: AddOrganization, throwError?: boolean): Observable<AddOrganizationModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<AddOrganizationModel>(url, model, this.jsonOptions), throwError);
  }

  deactivateOrganization(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/deactivate';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, {}, this.jsonOptions), throwError);
  }

  activateOrganization(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/activate';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, {}, this.jsonOptions), throwError);
  }

  addScopes(id: string, model: AddScopesToOrganization, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/scopes';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  getScopes(id: string, throwError?: boolean): Observable<ScopeListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/scopes';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeListModel[]>(url, this.jsonOptions), throwError);
  }

  isScopeRemovable(id: string, appId: string, scopeId: string, throwError?: boolean): Observable<boolean> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/apps/{appId}/scopes/{scopeId}/removable';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    if (scopeId === undefined || scopeId === null) {
        throw new Error('The parameter \'scopeId\' must be defined.');
    }
    url = url.replace('{scopeId}', encodeURIComponent('' + scopeId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<boolean>(url, this.jsonOptions), throwError);
  }

  removeScopes(id: string, appId: string, model: RemoveScopesFromOrganization, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/apps/{appId}/scopes';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getAssignableScopes(id: string, appId: string, throwError?: boolean): Observable<ScopeModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/apps/{appId}/assignable-scopes';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeModel[]>(url, this.jsonOptions), throwError);
  }

  addApps(id: string, model: AddAppsToOrganization, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/apps';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeApps(id: string, model: RemoveAppsFromOrganization, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/apps';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getApps(id: string, throwError?: boolean): Observable<AppModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/apps';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AppModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableApps(id: string, throwError?: boolean): Observable<AppModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/assignable-apps';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AppModel[]>(url, this.jsonOptions), throwError);
  }

  isAppRemovable(id: string, appId: string, throwError?: boolean): Observable<boolean> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/apps/{appId}/removable';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<boolean>(url, this.jsonOptions), throwError);
  }

  getScopeParameterValueById(id: string, scopeParameterValueId: string, throwError?: boolean): Observable<ScopeParameterValueModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/scopeparametervalues/{scopeParameterValueId}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (scopeParameterValueId === undefined || scopeParameterValueId === null) {
        throw new Error('The parameter \'scopeParameterValueId\' must be defined.');
    }
    url = url.replace('{scopeParameterValueId}', encodeURIComponent('' + scopeParameterValueId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterValueModel>(url, this.jsonOptions), throwError);
  }

  deleteScopeParameterValue(id: string, scopeParameterValueId: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/scopeparametervalues/{scopeParameterValueId}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (scopeParameterValueId === undefined || scopeParameterValueId === null) {
        throw new Error('The parameter \'scopeParameterValueId\' must be defined.');
    }
    url = url.replace('{scopeParameterValueId}', encodeURIComponent('' + scopeParameterValueId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  updateScopeParameterValue(id: string, scopeParameterValueId: string, model: UpdateScopeParameterValue, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/scopeparametervalues/{scopeParameterValueId}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (scopeParameterValueId === undefined || scopeParameterValueId === null) {
        throw new Error('The parameter \'scopeParameterValueId\' must be defined.');
    }
    url = url.replace('{scopeParameterValueId}', encodeURIComponent('' + scopeParameterValueId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getScopeParameterValues(id: string, throwError?: boolean): Observable<ScopeParameterValueListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/scopeparametervalues';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterValueListModel[]>(url, this.jsonOptions), throwError);
  }

  addScopeParameterValue(id: string, model: AddScopeParameterValue, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/scopeparametervalues';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  isScopeParameterValueDeletable(id: string, scopeParameterValueId: string, throwError?: boolean): Observable<boolean> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/scopeparametervalues/{scopeParameterValueId}/deletable';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (scopeParameterValueId === undefined || scopeParameterValueId === null) {
        throw new Error('The parameter \'scopeParameterValueId\' must be defined.');
    }
    url = url.replace('{scopeParameterValueId}', encodeURIComponent('' + scopeParameterValueId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<boolean>(url, this.jsonOptions), throwError);
  }

  getOrganizationInvitations(throwError?: boolean): Observable<OrganizationInvitationListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/invitations';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<OrganizationInvitationListModel[]>(url, this.jsonOptions), throwError);
  }

  revokeOrganizationInvitation(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/invitations/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  getBuiltInRoles(id: string, throwError?: boolean): Observable<RoleModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/builtinroles';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleModel[]>(url, this.jsonOptions), throwError);
  }

  addBuiltInRoles(id: string, model: AddBuiltInRolesToOrganization, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/builtinroles';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeBuiltInRoles(id: string, model: RemoveBuiltInRolesFromOrganization, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/builtinroles';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getAssignableBuiltInRoles(id: string, appId: string, throwError?: boolean): Observable<RoleModel[]> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/apps/{appId}/assignable-builtinroles';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined.');
    }
    url = url.replace('{appId}', encodeURIComponent('' + appId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleModel[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class RolesClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getRoles(filter?: string | null | undefined, sortField?: string | null | undefined, sortOrder?: SortOrder | undefined, skip?: number | null | undefined, take?: number | null | undefined, throwError?: boolean): Observable<PaginatedResultOfRoleModel> {
      let url = this.baseUrl + '/internal/v1.0/roles?';
    if (filter !== undefined) {
        url += 'Filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (sortField !== undefined) {
        url += 'SortField=' + encodeURIComponent('' + sortField) + '&'; 
    }
    if (sortOrder === null) {
        throw new Error('The parameter \'sortOrder\' cannot be null.');
    } else if (sortOrder !== undefined) {
        url += 'SortOrder=' + encodeURIComponent('' + sortOrder) + '&'; 
    }
    if (skip !== undefined) {
        url += 'Skip=' + encodeURIComponent('' + skip) + '&'; 
    }
    if (take !== undefined) {
        url += 'Take=' + encodeURIComponent('' + take) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PaginatedResultOfRoleModel>(url, this.jsonOptions), throwError);
  }

  addRole(model: AddRole, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/roles';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  getById(id: string, throwError?: boolean): Observable<RoleModel> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleModel>(url, this.jsonOptions), throwError);
  }

  updateRole(id: string, model: UpdateRole, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  deleteRole(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  addBuiltInRole(model: AddBuiltInRole, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/roles/builtin';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  updateBuiltInRole(id: string, model: UpdateRole, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/roles/builtin/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  addScopes(id: string, model: AddScopesToRole, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}/scopes';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeScopes(id: string, model: RemoveScopesFromRole, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}/scopes';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getScopes(id: string, throwError?: boolean): Observable<ScopeListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}/scopes';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableScopes(id: string, appId: string, throwError?: boolean): Observable<ScopeModel[]> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}/assignable-scopes?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (appId === undefined || appId === null) {
        throw new Error('The parameter \'appId\' must be defined and cannot be null.');
    } else {
        url += 'appId=' + encodeURIComponent('' + appId) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeModel[]>(url, this.jsonOptions), throwError);
  }

  getRoleAssignments(id: string, throwError?: boolean): Observable<RoleAssignmentListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleAssignmentListModel[]>(url, this.jsonOptions), throwError);
  }

  getOrganizations(id: string, throwError?: boolean): Observable<RoleOrganizationAssignment[]> {
      let url = this.baseUrl + '/internal/v1.0/roles/{id}/organizations';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleOrganizationAssignment[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ScopeParameterNamesClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getScopeParameterNames(throwError?: boolean): Observable<ScopeParameterNameModel[]> {
      let url = this.baseUrl + '/internal/v1.0/scopeparameternames';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterNameModel[]>(url, this.jsonOptions), throwError);
  }

  addScopeParameterName(model: AddScopeParameterName, throwError?: boolean): Observable<string> {
      let url = this.baseUrl + '/internal/v1.0/scopeparameternames';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<string>(url, model, this.jsonOptions), throwError);
  }

  getById(id: string, throwError?: boolean): Observable<ScopeParameterNameModel> {
      let url = this.baseUrl + '/internal/v1.0/scopeparameternames/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterNameModel>(url, this.jsonOptions), throwError);
  }

  updateScopeParameterName(id: string, model: UpdateScopeParameterName, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/scopeparameternames/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  deleteScopeParameterName(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/scopeparameternames/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  isDeletable(id: string, throwError?: boolean): Observable<boolean> {
      let url = this.baseUrl + '/internal/v1.0/scopeparameternames/{id}/deletable';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<boolean>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SessionsClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getSessions(minCreatedDate?: Date | undefined, maxCreatedDate?: Date | undefined, filter?: string | null | undefined, sortField?: string | null | undefined, sortOrder?: SortOrder | undefined, skip?: number | null | undefined, take?: number | null | undefined, throwError?: boolean): Observable<PaginatedResultOfSessionListModel> {
      let url = this.baseUrl + '/internal/v1.0/sessions?';
    if (minCreatedDate === null) {
        throw new Error('The parameter \'minCreatedDate\' cannot be null.');
    } else if (minCreatedDate !== undefined) {
        url += 'MinCreatedDate=' + encodeURIComponent(minCreatedDate ? '' + minCreatedDate.toJSON() : '') + '&'; 
    }
    if (maxCreatedDate === null) {
        throw new Error('The parameter \'maxCreatedDate\' cannot be null.');
    } else if (maxCreatedDate !== undefined) {
        url += 'MaxCreatedDate=' + encodeURIComponent(maxCreatedDate ? '' + maxCreatedDate.toJSON() : '') + '&'; 
    }
    if (filter !== undefined) {
        url += 'Filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (sortField !== undefined) {
        url += 'SortField=' + encodeURIComponent('' + sortField) + '&'; 
    }
    if (sortOrder === null) {
        throw new Error('The parameter \'sortOrder\' cannot be null.');
    } else if (sortOrder !== undefined) {
        url += 'SortOrder=' + encodeURIComponent('' + sortOrder) + '&'; 
    }
    if (skip !== undefined) {
        url += 'Skip=' + encodeURIComponent('' + skip) + '&'; 
    }
    if (take !== undefined) {
        url += 'Take=' + encodeURIComponent('' + take) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PaginatedResultOfSessionListModel>(url, this.jsonOptions), throwError);
  }

  deleteSession(sessionId: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/sessions/{sessionId}';
    if (sessionId === undefined || sessionId === null) {
        throw new Error('The parameter \'sessionId\' must be defined.');
    }
    url = url.replace('{sessionId}', encodeURIComponent('' + sessionId)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  bulkDeleteSessions(request: BulkDeleteSessions, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/sessions/bulk-delete';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, request, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserInvitationsClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  verify(id: string, token?: string | undefined, throwError?: boolean): Observable<VerifyInvitationModel> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/invitations/verify?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (token === null) {
        throw new Error('The parameter \'token\' cannot be null.');
    } else if (token !== undefined) {
        url += 'Token=' + encodeURIComponent('' + token) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<VerifyInvitationModel>(url, this.jsonOptions), throwError);
  }

  acceptInvitation(id: string, token?: string | undefined, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/organizations/{id}/invitations/accept?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (token === null) {
        throw new Error('The parameter \'token\' cannot be null.');
    } else if (token !== undefined) {
        url += 'Token=' + encodeURIComponent('' + token) + '&'; 
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class UsersClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getById(id: string, throwError?: boolean): Observable<UserModel> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<UserModel>(url, this.jsonOptions), throwError);
  }

  updateUser(id: string, model: UpdateUser, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  deleteUser(id: string, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<void>(url, this.jsonOptions), throwError);
  }

  getUsers(filter?: string | null | undefined, sortField?: string | null | undefined, sortOrder?: SortOrder | undefined, skip?: number | null | undefined, take?: number | null | undefined, tagIds?: string[] | null | undefined, throwError?: boolean): Observable<PaginatedResultOfUserListModel> {
      let url = this.baseUrl + '/internal/v1.0/users?';
    if (filter !== undefined) {
        url += 'Filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (sortField !== undefined) {
        url += 'SortField=' + encodeURIComponent('' + sortField) + '&'; 
    }
    if (sortOrder === null) {
        throw new Error('The parameter \'sortOrder\' cannot be null.');
    } else if (sortOrder !== undefined) {
        url += 'SortOrder=' + encodeURIComponent('' + sortOrder) + '&'; 
    }
    if (skip !== undefined) {
        url += 'Skip=' + encodeURIComponent('' + skip) + '&'; 
    }
    if (take !== undefined) {
        url += 'Take=' + encodeURIComponent('' + take) + '&'; 
    }
    if (tagIds !== undefined) {
        tagIds && tagIds.forEach(item => { url += 'TagIds=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PaginatedResultOfUserListModel>(url, this.jsonOptions), throwError);
  }

  getGroups(id: string, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  addGroups(id: string, model: AddGroupsToUser, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeGroups(id: string, model: RemoveGroupsFromUser, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/groups';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getAssignableGroups(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<GroupListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/assignable-groups?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<GroupListModel[]>(url, this.jsonOptions), throwError);
  }

  getRoleAssignments(id: string, throwError?: boolean): Observable<RoleAssignmentListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleAssignmentListModel[]>(url, this.jsonOptions), throwError);
  }

  addRoleAssignments(id: string, model: AddRoleAssignments, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeRoleAssignments(id: string, model: RemoveRoleAssignment, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/roleassignments';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getPermissions(id: string, throwError?: boolean): Observable<PermissionsListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/permissions';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<PermissionsListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableScopeParameterValues(roleId?: string | undefined, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<ScopeParameterValueListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/assignable-scopeparametervalues?';
    if (roleId === null) {
        throw new Error('The parameter \'roleId\' cannot be null.');
    } else if (roleId !== undefined) {
        url += 'roleId=' + encodeURIComponent('' + roleId) + '&'; 
    }
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ScopeParameterValueListModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableRoles(filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<RoleListModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/assignable-roles?';
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<RoleListModel[]>(url, this.jsonOptions), throwError);
  }

  getTags(id: string, throwError?: boolean): Observable<TagModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/tags';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<TagModel[]>(url, this.jsonOptions), throwError);
  }

  addTags(id: string, model: AddTags, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/tags';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  removeTags(id: string, model: RemoveTags, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/tags';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.patch<void>(url, model, this.jsonOptions), throwError);
  }

  getOrganizationTags(filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<TagSelectionModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/tags?';
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<TagSelectionModel[]>(url, this.jsonOptions), throwError);
  }

  getAssignableTags(id: string, filter?: string | null | undefined, selection?: string[] | null | undefined, throwError?: boolean): Observable<TagSelectionModel[]> {
      let url = this.baseUrl + '/internal/v1.0/users/{id}/assignable-tags?';
    if (id === undefined || id === null) {
        throw new Error('The parameter \'id\' must be defined.');
    }
    url = url.replace('{id}', encodeURIComponent('' + id)); 
    if (filter !== undefined) {
        url += 'filter=' + encodeURIComponent('' + filter) + '&'; 
    }
    if (selection !== undefined) {
        selection && selection.forEach(item => { url += 'selection=' + encodeURIComponent('' + item) + '&'; });
    }
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<TagSelectionModel[]>(url, this.jsonOptions), throwError);
  }
}

export interface AppModel {
    id: string;
    name: string;
    audience: string;
    requireResourceIndicator: boolean;
}

export interface AddApp {
    name: string;
    audience: string;
    requireResourceIndicator: boolean;
}

export interface UpdateApp {
    name: string;
}

export interface ScopeModel {
    id: string;
    value: string;
    isApiResourceUserScope: boolean;
    description?: string | undefined;
}

export interface AddScope {
    value: string;
    description?: string | undefined;
    isApiResourceUserScope: boolean;
}

export interface UpdateScope {
    description?: string | undefined;
    isApiResourceUserScope: boolean;
}

export interface AddScopeParameterNamesToApp {
    scopeParameterNames: string[];
}

export interface RemoveScopeParameterNamesFromApp {
    scopeParameterNames: string[];
}

export interface ScopeParameterNameModel {
    id: string;
    name: string;
    description?: string | undefined;
}

export interface RoleModel {
    id: string;
    name: string;
    isBuiltInRole: boolean;
    isReadOnly: boolean;
    appId?: string | undefined;
    appName?: string | undefined;
    description?: string | undefined;
}

export interface PaginatedResultOfAuditListModel {
    items: AuditListModel[];
    totalCount: number;
}

export interface AuditListModel {
    id: string;
    createdDate: Date;
    activity: AuditActivity;
    actorId: string;
    actorName: string;
    targetId: string;
    targetName: string;
    targetType: AuditTargetType;
}

export enum AuditActivity {
    AddRole = 100,
    UpdateRole = 101,
    DeleteRole = 102,
    AddRoleToOrganization = 103,
    RemoveRoleFromOrganization = 104,
    AddGroup = 200,
    UpdateGroup = 201,
    DeleteGroup = 202,
    AddGroupToRole = 203,
    RemoveGroupFromRole = 204,
    AddGroupToGroup = 205,
    RemoveGroupFromGroup = 206,
    AddUser = 300,
    UpdateUser = 301,
    DeleteUser = 302,
    AddUserToRole = 303,
    RemoveUserFromRole = 304,
    AddUserToGroup = 305,
    RemoveUserFromGroup = 306,
    AddUserToGroupAsOwner = 307,
    RemoveUserFromGroupAsOwner = 308,
    AddClient = 400,
    UpdateClient = 401,
    DeleteClient = 402,
    AddClientToRole = 403,
    RemoveClientFromRole = 404,
    AddClientToGroup = 405,
    RemoveClientFromGroup = 406,
    AddOrganization = 500,
    UpdateOrganization = 501,
    DeleteOrganization = 502,
    ActivateOrganization = 503,
    DeactivateOrganization = 504,
    AddApp = 600,
    UpdateApp = 601,
    DeleteApp = 602,
    AddAppToOrganization = 603,
    RemoveAppFromOrganization = 604,
    AddRedirectUri = 700,
    DeleteRedirectUri = 702,
    AddPostLogoutRedirectUri = 703,
    DeletePostLogoutRedirectUri = 704,
    AddInvitation = 800,
    UpdateInvitation = 801,
    DeleteInvitation = 802,
    AddInvitationToRole = 803,
    RemoveInvitationFromRole = 804,
    AddInvitationToGroup = 805,
    RemoveInvitationFromGroup = 806,
    AddScope = 900,
    UpdateScope = 901,
    DeleteScope = 902,
    AddScopeToOrganization = 903,
    RemoveScopeFromOrganization = 904,
    AddScopeToRole = 905,
    RemoveScopeFromRole = 906,
    AddScopeParameterName = 1000,
    UpdateScopeParameterName = 1001,
    DeleteScopeParameterName = 1002,
    AddScopeParameterNameToApp = 1003,
    RemoveScopeParameterNameFromApp = 1004,
    AddScopeParameterValue = 1100,
    UpdateScopeParameterValue = 1101,
    DeleteScopeParameterValue = 1102,
    AddScopeParameterValueToRole = 1103,
    RemoveScopeParameterValueFromRole = 1104,
    AddSecret = 1200,
    DeleteSecret = 1201,
    AddApiKey = 1300,
    DeleteApiKey = 1301,
    AddRoleAssignmentToUser = 1400,
    AddRoleAssignmentToInvitation = 1401,
    AddRoleAssignmentToClient = 1402,
    AddRoleAssignmentToGroup = 1403,
    RemoveRoleAssignmentFromUser = 1404,
    RemoveRoleAssignmentFromInvitation = 1405,
    RemoveRoleAssignmentFromClient = 1406,
    RemoveRoleAssignmentFromGroup = 1407,
    AddTag = 1500,
    UpdateTag = 1501,
    DeleteTag = 1502,
    AddTagToClient = 1503,
    RemoveTagFromClient = 1504,
    AddTagToUser = 1505,
    RemoveTagFromUser = 1506,
}

export enum AuditTargetType {
    Role = 1,
    Group = 2,
    User = 3,
    Client = 4,
    Organization = 5,
    App = 6,
    RedirectUri = 7,
    Invitation = 8,
    Scope = 9,
    ScopeParameterName = 10,
    ScopeParameterValue = 11,
    Secret = 12,
    ApiKey = 13,
    PostLogoutRedirectUri = 14,
    Tag = 15,
}

export interface AuditModel {
    id: string;
    createdDate: Date;
    activity: AuditActivity;
    actorId: string;
    actorName?: string | undefined;
}

export interface AuditTargetListModel {
    targetId: string;
    targetName: string;
    targetType: AuditTargetType;
}

export interface AuditChangeListModel {
    propertyName: string;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export interface PaginatedResultOfClientListModel {
    items: ClientListModel[];
    totalCount: number;
}

export interface ClientListModel {
    id: string;
    clientKind: ClientKind;
    name: string;
    clientId: string;
    leastImminentExpiration?: Date | undefined;
    tags: string[];
}

export enum ClientKind {
    Unknown = 0,
    SinglePageApplication = 1,
    MachineToMachine = 2,
    TokenExchange = 3,
    ApiKey = 4,
    RegularWebApplication = 5,
}

export enum SortOrder {
    Undefined = 0,
    Asc = 1,
    Desc = -1,
}

export interface ClientModel {
    id: string;
    clientKind: ClientKind;
    name: string;
    clientId: string;
    accessTokenType: AccessTokenType;
    accessTokenLifetime: number;
    hasMemberships: boolean;
    backChannelLogoutUri?: string | undefined;
    frontChannelLogoutUri?: string | undefined;
    tagIds: string[];
}

export enum AccessTokenType {
    Unknown = 0,
    Reference = 1,
    Jwt = 2,
}

export interface UpdateClient {
    name: string;
    accessTokenType: AccessTokenType;
    accessTokenLifetime: number;
    backChannelLogoutUri?: string | undefined;
    frontChannelLogoutUri?: string | undefined;
}

export interface AddClient {
    name: string;
    clientKind: ClientKind;
    accessTokenType: AccessTokenType;
    accessTokenLifetime: number;
}

export interface PermissionsListModel {
    value: string;
}

export interface GroupListModel {
    id: string;
    name: string;
    description?: string | undefined;
}

export interface AddGroupsToClient {
    groups: string[];
}

export interface RemoveGroupsFromClient {
    groups: string[];
}

export interface RedirectUriListModel {
    id: string;
    redirectUri: string;
}

export interface AddRedirectUri {
    redirectUri: string;
}

export interface PostLogoutRedirectUriListModel {
    id: string;
    postLogoutRedirectUri: string;
}

export interface AddPostLogoutRedirectUri {
    postLogoutRedirectUri: string;
}

export interface SecretListModel {
    id: string;
    description: string;
    expiration: Date;
}

export interface AddSecretModel {
    secret: string;
}

export interface AddSecret {
    description: string;
    expiration: Date;
}

export interface AddApiKeyModel {
    apiKey: string;
}

export interface AddApiKey {
    description: string;
    expiration: Date;
    app: string;
    scopes: string[];
}

export interface ApiKeyListModel {
    id: string;
    description: string;
    expiration: Date;
}

export interface ApiKeyAppsListModel {
    id: string;
    name: string;
}

export interface RoleAssignmentListModel {
    id: string;
    hasDynamicScope: boolean;
    affectedEntityId: string;
    affectedEntityName: string;
    affectedEntityType: string;
    assignedEntityId: string;
    assignedEntityName: string;
    assignedEntityType: string;
    isInherited: boolean;
    roleId: string;
    roleName: string;
    scopeParameters: RoleAssignmentListScopeParameterModel[];
}

export interface RoleAssignmentListScopeParameterModel {
    name: RoleAssignmentListScopeParameterNameModel;
    value: RoleAssignmentListScopeParameterValueModel;
}

export interface RoleAssignmentListScopeParameterNameModel {
    id: string;
    value: string;
    description?: string | undefined;
}

export interface RoleAssignmentListScopeParameterValueModel {
    id: string;
    value: string;
    description?: string | undefined;
}

export interface AddRoleAssignments {
    roleId: string;
    scopeParameterValueIds: string[];
}

export interface RemoveRoleAssignment {
    roleId: string;
    scopeParameterValueIds: string[];
}

export interface ScopeParameterValueListModel {
    name: string;
    nameId: string;
    id: string;
    value: string;
    description?: string | undefined;
}

export interface RoleListModel {
    id: string;
    name: string;
    description?: string | undefined;
}

export interface TagModel {
    id: string;
    name: string;
    value: string;
}

export interface AddTags {
    tagIds: string[];
}

export interface RemoveTags {
    tagIds: string[];
}

export interface TagSelectionModel {
    id: string;
    tag: string;
}

export interface ConfigurationModel {
    appInsights: ApplicationInsightsModel;
    authConfig: AngularAuthConfigModel;
}

export interface ApplicationInsightsModel {
    connectionString: string;
}

export interface AngularAuthConfigModel {
    redirectUri: string;
    postLogoutRedirectUri: string;
    myAccountUri: string;
    clientId: string;
    issuer: string;
    responseType: string;
    scope: string;
    resource: string;
    mfaSetupUri: string;
    acrValues: string;
}

export interface GroupModel {
    id: string;
    name: string;
    description?: string | undefined;
    hasMemberships: boolean;
}

export interface UserNameListModel {
    id: string;
    displayName: string;
    email: string;
}

export interface ClientNameListModel {
    id: string;
    name: string;
    clientId: string;
}

export interface AddUsersToGroup {
    users: string[];
}

export interface AddOwnersToGroup {
    owners: string[];
}

export interface AddClientsToGroup {
    clients: string[];
}

export interface AddGroupsToGroup {
    groups: string[];
}

export interface AddGroupMembershipsToGroup {
    groups: string[];
}

export interface RemoveUsersFromGroup {
    users: string[];
}

export interface RemoveClientsFromGroup {
    clients: string[];
}

export interface RemoveGroupsFromGroup {
    groups: string[];
}

export interface RemoveOwnersFromGroup {
    owners: string[];
}

export interface UpdateGroup {
    name: string;
    description?: string | undefined;
}

export interface AddGroup {
    name: string;
    description?: string | undefined;
}

export interface InvitationListModel {
    id: string;
    email: string;
    sentDate: Date;
}

export interface InvitationModel {
    id: string;
    email: string;
    sentDate: Date;
    displayName?: string | undefined;
    familyName?: string | undefined;
    givenName?: string | undefined;
}

export interface BulkRevokeInvitations {
    invitations: string[];
}

export interface BulkResendInvitations {
    invitations: string[];
}

export interface AddInvitationModel {
    id: string;
    organizationId: string;
    email: string;
    invitationUri: string;
}

export interface CreateInvitation {
    email: string;
    language: string;
    displayName?: string | undefined;
    familyName?: string | undefined;
    givenName?: string | undefined;
}

export interface UpdateInvitation {
    displayName?: string | undefined;
    familyName?: string | undefined;
    givenName?: string | undefined;
}

export interface AddGroupsToInvitation {
    groups: string[];
}

export interface RemoveGroupsFromInvitation {
    groups: string[];
}

export interface UserScopeParameterValueModel {
    value: string;
    description?: string | undefined;
}

export interface UserScopeParametersResultModel {
    items?: UserScopeParameterModel[][];
}

export interface UserScopeParameterModel {
    name?: string;
    value?: string;
    description?: string | undefined;
}

export interface UserScopesModel {
    values: string[];
}

export interface ValidatedCallbackUrlResponseModel {
    validatedCallbackUrl: string;
}

export interface ValidateCallbackUrlModel {
    callbackUrl: string;
}

export interface OrganizationOverviewModel {
    id: string;
    referenceNumber: number;
    name: string;
    userCount: number;
    clientCount: number;
    groupCount: number;
    appCount: number;
}

export interface OrganizationSourceVendorModel {
    id: string;
    sourceVendor: SourceVendor;
}

export enum SourceVendor {
    Unknown = 0,
    Microsoft = 1,
    Google = 2,
    Apple = 3,
}

export interface SetSourceVendor {
    sourceVendor: SourceVendor;
}

export interface PaginatedResultOfTagModel {
    items: TagModel[];
    totalCount: number;
}

export interface TagNameSelectionModel {
    name: string;
}

export interface AddTag {
    name: string;
    value: string;
}

export interface UpdateTag {
    name: string;
    value: string;
}

export interface OrganizationModel {
    id: string;
    referenceNumber: number;
    name: string;
    isActive: boolean;
    isSystemOrganization: boolean;
}

export interface UpdateOrganization {
    name: string;
}

export interface AddOrganizationModel {
    id: string;
    referenceNumber: number;
    name: string;
    invitation: AddInvitationModel;
}

export interface AddOrganization {
    name: string;
    email: string;
}

export interface AddScopesToOrganization {
    app: string;
    scopes: string[];
}

export interface ScopeListModel {
    app: string;
    appId: string;
    scope: string;
    scopeId: string;
    description?: string | undefined;
}

export interface RemoveScopesFromOrganization {
    scopes: string[];
}

export interface AddAppsToOrganization {
    apps: string[];
}

export interface RemoveAppsFromOrganization {
    apps: string[];
}

export interface ScopeParameterValueModel {
    id: string;
    name: string;
    value: string;
    description?: string | undefined;
}

export interface AddScopeParameterValue {
    scopeParameterName: string;
    value: string;
    description?: string | undefined;
}

export interface UpdateScopeParameterValue {
    description?: string | undefined;
}

export interface OrganizationInvitationListModel {
    id: string;
    email: string;
    sentDate: Date;
    organizationId: string;
    organizationName: string;
}

export interface AddBuiltInRolesToOrganization {
    app: string;
    roleIds: string[];
}

export interface RemoveBuiltInRolesFromOrganization {
    roleIds: string[];
}

export interface PaginatedResultOfRoleModel {
    items: RoleModel[];
    totalCount: number;
}

export interface UpdateRole {
    name: string;
    description?: string | undefined;
}

export interface AddRole {
    name: string;
    description?: string | undefined;
}

export interface AddBuiltInRole {
    name: string;
    app: string;
    description?: string | undefined;
}

export interface AddScopesToRole {
    app: string;
    scopes: string[];
}

export interface RemoveScopesFromRole {
    app: string;
    scopes: string[];
}

export interface RoleOrganizationAssignment {
    id: string;
    name: string;
    referenceNumber: number;
    numberOfRoleAssignments: number;
}

export interface UpdateScopeParameterName {
    description?: string | undefined;
}

export interface AddScopeParameterName {
    name: string;
    description?: string | undefined;
}

export interface PaginatedResultOfSessionListModel {
    items: SessionListModel[];
    totalCount: number;
}

export interface SessionListModel {
    id: string;
    subjectId: string;
    key: string;
    displayName: string;
    created: Date;
    renewed: Date;
    expires?: Date | undefined;
}

export interface BulkDeleteSessions {
    sessionIds: string[];
}

export interface VerifyInvitationModel {
    organizationName: string;
}

export interface UserModel {
    id: string;
    displayName: string;
    familyName?: string | undefined;
    givenName?: string | undefined;
    email: string;
    tagIds: string[];
}

export interface PaginatedResultOfUserListModel {
    items: UserListModel[];
    totalCount: number;
}

export interface UserListModel {
    id: string;
    displayName: string;
    email: string;
    membershipType: MembershipType;
    tags: string[];
}

export enum MembershipType {
    Unknown = 0,
    Member = 1,
    Owner = 2,
}

export interface UpdateUser {
    displayName: string;
    familyName?: string | undefined;
    givenName?: string | undefined;
}

export interface AddGroupsToUser {
    groups: string[];
}

export interface RemoveGroupsFromUser {
    groups: string[];
}